<template>
  <el-popover
    width="200"
    placement="bottom"
    :visible-arrow="false"
    popper-class="langSelectPopper"
    v-model="isOpen"
  >
    <el-row :gutter="20">
      <el-col :span="24" v-for="item in I18NList" :key="item.code">
        <div
          :class="['langItem', { activeLang: $i18n.locale === item.code }]"
          @click="changeLanguage(item.code)"
        >
          <span>{{ item.name }}</span>
          <div v-if="$i18n.locale === item.code" class="activeLangDot" />
        </div>
      </el-col>
    </el-row>

    <div slot="reference" class="langSelectWrapper" @click="handleClick">
      <img src="@/assets/images/LanguageIcon.svg" alt="" class="langIcon" />
      <span class="langTxt">{{ languageTxt }}</span>
    </div>
  </el-popover>
</template>

<script>
import { mapState } from "vuex";
import { find } from "lodash";
import { I18NList } from "@/shared/const/langType";
import Bus from "../../plugins/bus";

export default {
  name: "LangSelect",
  computed: {
    ...mapState(["lang", "mobileFlag"]),
  },
  data() {
    return {
      I18NList,
      languageTxt: "",
      isOpen: false,
    };
  },
  watch: {
    isOpen(newVal) {
      const mainContentDom = document.getElementById("app");
      if (mainContentDom.firstElementChild) {
        mainContentDom.firstElementChild.style.overflow = newVal
          ? "hidden"
          : "scroll";
      }
    },
  },
  created() {
    this.$store.commit("setLang", this.lang);
    const currentLangInfo = find(this.I18NList, { code: this.lang });
    this.languageTxt = currentLangInfo.name;
  },
  methods: {
    handleClick() {
      Bus.$emit("isMobileMenu", false);
    },
    changeLanguage(nextLangCode) {
      if (this.$i18n.locale !== nextLangCode) {
        this.$i18n.locale = nextLangCode;
        this.$store.commit("setLang", nextLangCode);
        const nextLangInfo = find(this.I18NList, { code: nextLangCode });
        this.languageTxt = nextLangInfo.name;
        this.$emit("onChange");
        this.isOpen = false;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.langSelectWrapper {
  display: flex;
  align-items: center;
  cursor: pointer;
  gap: 5px;
}

.langIcon {
  width: 20px;
  height: 20px;
}

.langTxt {
  line-height: 20px;
  color: #0b205d;
  font-size: 14px;
  font-weight: 500;
}

.langItem {
  cursor: pointer;
  margin-top: 10px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}

.activeLang {
  color: #0b205d;
  cursor: default;
}

.activeLangDot {
  margin-left: 8px;
  padding: 4px;
  background-color: #4d71ff;
  border-radius: 100%;
}

@media screen and (max-width: 767px) {
  .langSelectWrapper {
    margin-right: 20px;
  }
}
</style>
